import { PartnerCreatePage } from "@/features/partner/pages/PartnerCreate";

const PartnerCreate = () => {
  return <PartnerCreatePage />;
};

export default PartnerCreate;
